import { motion } from "framer-motion";
import { SERVICES } from "@/data/site";
import Icon from "@/components/Icon";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function Services() {
    const { t } = useLang();
    return (
        <section id="services" data-testid="services-section" className="relative py-24 md:py-32 bg-navy">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <Reveal>
                    <Eyebrow>{t.services.eyebrow}</Eyebrow>
                    <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-ink mt-4">
                        {t.services.heading}
                    </h2>
                </Reveal>
                <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.icon} delay={(i % 3) * 0.12}>
                            <motion.div
                                data-testid={`service-card-${s.icon}`}
                                whileHover={{ y: -6 }}
                                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                                className="group h-full rounded-2xl border border-ink/5 bg-surface p-7 hover:border-cyan2/30 transition-colors duration-300"
                            >
                                <span className="w-12 h-12 rounded-xl bg-gradient-to-br from-electric/25 to-cyan2/15 border border-cyan2/20 flex items-center justify-center group-hover:shadow-[0_0_25px_rgba(0,207,255,0.3)] transition-shadow duration-300">
                                    <Icon name={s.icon} size={22} className="text-cyan2" />
                                </span>
                                <h3 className="font-heading text-lg font-semibold text-ink mt-5">
                                    {t.services.items[i].title}
                                </h3>
                                <p className="mt-2 text-sm text-ice/60 leading-relaxed">
                                    {t.services.items[i].description}
                                </p>
                            </motion.div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
